export const resizeImageHeight = (imageClass, containerClass, hasSocialMedia) => {
  const image = document.querySelectorAll(imageClass)
  const socialMediaSize = hasSocialMedia ? 122 : 51
  const max = document.documentElement.scrollHeight - document.documentElement.clientHeight - socialMediaSize
  if (!image || !image.length) return
  if (window.scrollY >= max) {
    image[0].style.height = `calc(100% - ${window.scrollY - max + 2}px)`
  } else {
    image[0].style.height = '100%'
  }
  resizeImageWidth(imageClass, containerClass)
}

export const resizeImageWidth = (imageClass, containerClass) => {
  const image = document.querySelector(imageClass)
  const container = document.querySelector(containerClass)
  const imageWidth = image.clientWidth
  if (container) container.style.width = `calc(100% - ${imageWidth}px)`
}
